import VideoConferenceContainer from './video-conference-container';

export default VideoConferenceContainer;